import { AddToCartService } from "~/AddToCart/AddToCartService";
import { IconClickable } from "~/common/components/icon/IconClickable";
import { IconType } from "~/common/components/icon/IconType";
import { usePurchasePlace, usePurchaseType } from "~/feature/Analytics/ga/recommendations/RecommendationContexts";
import type { PurchaseType } from "~/feature/Analytics/ga/recommendations/types";

export const AddToCartAction = ({ productCode }: { productCode: string }) => {
  const purchase_place = usePurchasePlace();
  const purchase_type = usePurchaseType();
  const openAddToCart = () => {
    AddToCartService.openAddToCartWizard(
      {
        productCode: productCode,
        restrictionQuery: "",
      },
      {
        page: purchase_place,
        recommendationType: purchase_type,
        recommendationPlace: purchase_place,
      },
    );
  };

  return (
    <IconClickable
      data-test-id={"tabular-view-action-button-add-to-cart"}
      type={IconType.Cart}
      disabled={window.SCHA.config.disableAllWS}
      inverted={true}
      onIconClick={openAddToCart}
      data-ta-spec={"housing_assistant_product_cart"}
    />
  );
};
